//
// Хук для запроса у API списка объектов
//
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from '../utils/api';

const useApiList = ({ method, find, skip, limit, role, admin, event, archived }) => {
    const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		const fetchData = async (find) => {
			setIsLoading(true);
			setData(null);
			setError('');
			const result = await get(method, { find, skip, limit, role, admin, event, archived });
			if(result.error) {
				setError(result.error);
			} else {
				setData(result.data);
			}
			setIsLoading(false);
		};

		fetchData(find.trim());
	}, [ method, find, skip, limit, role, admin, event, archived ]);

    return [ data, error, isLoading ];
};

useApiList.propTypes = {
    method: PropTypes.string.isRequired,
    find: PropTypes.string.isRequired,
    skip: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
	role: PropTypes.string.isRequired,
	admin: PropTypes.string.isRequired,
	event: PropTypes.string.isRequired,
	archived: PropTypes.string.isRequired,
};

useApiList.defaultProps = {
	role: '',
	admin: '',
	event: '',
	archived: '',
};

export default useApiList;
